export enum FirmProfilePageTableMode {
  Staff = 'Staff',
  Department = 'Departments',
  Location = 'Locations',
  RequestType = 'Request-Types'
}
